import {
  DECISION_REASON,
  DECISION_VIOLATIONS,
  IS_NEED_TO_ADD_ACT_ID,
  KNM_DOCUMENTS,
  getAgreementsBlockId,
  getComplexDataBlockId,
  getDecisionRiskIndicatorsBlockId,
  UAV_TECHNOLOGIES,
} from 'CorePackage/MainModule/routes/routes';
import {
  ACT_BLOCK_ID,
  INSPECTORS_BLOCK_ID,
  JUDGMENTS_BLOCK_ID,
  OBJECTS_BLOCK_ID,
  PROSECUTOR_ORGANIZATION_BLOCK_ID,
  getJudgmentActionBlockId,
  getJudgmentAttachmentBlockId,
  getJudgmentBlockId,
  getJudgmentCourtBlockId,
  getJudgmentCourtLevelBlockId,
  getJudgmentDateBlockId,
  getJudgmentKindBlockId,
  getJudgmentNumberBlockId,
  getJudgmentRfRegionBlockId,
  getJudgmentSubjectDataBlockId,
  EVENTS_BLOCK_ID,
  getEventBlockId,
  getEventTypeBlockId,
  getEventInteractionCategoryBlockId,
  getEventStartDateBlockId,
  getEventStopDateBlockId,
  getUavTechnologiesNameBlockId,
  getUavTechnologiesTypeBlockId,
} from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import {
  COUNTRY_BLOCK_ID,
  DOCUMENT_BLOCK_ID,
  INN_LABEL_BLOCK_ID,
  KPP_BLOCK_ID,
  LOCATION_ADDRESS,
  OGRN_LABEL_BLOCK_ID,
  ORGANIZATION_NAME_BLOCK_ID,
  RAFP_NZA_BLOCK_ID,
  SNILS_BLOCK_ID,
} from 'KnmPackage/KnmSubjectModule/constants/knmSubjectFieldsElementsIds';

import {
  DECISION_RESULT_BLOCK_ID,
  KNO_ORGANIZATION_BLOCK_ID,
  ORGANIZATION_BLOCK_ID,
} from './decisionFieldsElementsIds';
import { DecisionFormFieldsNamesTemplatesEnum } from '../enums/DecisionFormFieldsNamesTemplatesEnum';
import {
  getObjectAddressBlockId,
  getObjectBlockId,
  getObjectDangerClassBlockId,
  getObjectKindBlockId,
  getObjectManualAddressBlockId,
  getObjectNameBlockId,
  getObjectRegionBlockId,
  getObjectRiskCategoryBlockId,
  getObjectSubKindBlockId,
  getObjectTypeBlockId,
} from '../../../KnmPackage/MainModule/constants/fieldsElementsIds';
import { KnmErknmFormFieldsNamesTemplatesEnum } from '../../../KnmErknmPackage/MainModule/enums/KnmErknmFormFieldsNamesTemplatesEnum';

interface IFieldData {
  title: string;
  getScrollElementId: (id?: string) => string;
  getReserveScrollElementId?: (id?: string) => string;
}

export const decisionFieldsDataByFlatNameMap = (): Record<DecisionFormFieldsNamesTemplatesEnum[number], IFieldData> => {
  return {
    [DecisionFormFieldsNamesTemplatesEnum.KNO_ORGANIZATION]: {
      title: 'Контрольный (надзорный) орган',
      getScrollElementId: () => KNO_ORGANIZATION_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.KIND_CONTROL]: {
      title: 'Вид контроля (надзора) и его номер',
      getScrollElementId: () => KNO_ORGANIZATION_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.KIND]: {
      title: 'Вид контрольного (надзорного) мероприятия, специального режима',
      getScrollElementId: () => KNO_ORGANIZATION_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.BASIS_DOCUMENT_DATE_TIME]: {
      title: 'Дата документа',
      getScrollElementId: () => KNO_ORGANIZATION_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.BASIS_DOCUMENT_NUMBER]: {
      title: 'Номер документа',
      getScrollElementId: () => KNO_ORGANIZATION_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.IS_NEED_TO_ADD_ACT]: {
      title: 'Будет ли добавлен акт',
      getScrollElementId: () => IS_NEED_TO_ADD_ACT_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.IS_VIOLATED_REQUIREMENTS_MANDATORY]: {
      title: 'Выявленные нарушенные обязательные требования',
      getScrollElementId: () => DECISION_VIOLATIONS,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS]: {
      title: 'Выявленные нарушения обязательных требований',
      getScrollElementId: () => DECISION_VIOLATIONS,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE]: {
      title: 'Выявленные нарушения обязательных требований - Нарушения',
      getScrollElementId: () => DECISION_VIOLATIONS,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED_ON_PLACE]: {
      title: 'Выявленные нарушения обязательных требований - Нарушения',
      getScrollElementId: () => DECISION_VIOLATIONS,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATIONS]: {
      title: 'Выявленные нарушения обязательных требований - Нарушения',
      getScrollElementId: () => DECISION_VIOLATIONS,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED]: {
      title: 'Выявленные нарушения обязательных требований - Нарушения',
      getScrollElementId: () => DECISION_VIOLATIONS,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_VIOLATION_REPEAT_CORRECTED]: {
      title: 'Выявленные нарушения обязательных требований - Нарушение устранено',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES_VIDEO_LINK]: {
      title: 'Выявленные нарушения обязательных требований - Ссылка на файл устранения нарушения',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES]: {
      title: 'Выявленные нарушения обязательных требований - Файлы устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION]: {
      title: 'Выявленные нарушения обязательных требований - Сведения о факте устранения нарушения',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPES]: {
      title: 'Выявленные нарушения обязательных требований - Тип материала',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPE]: {
      title: 'Выявленные нарушения обязательных требований - Тип материала',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_METHOD]: {
      title: 'Выявленные нарушения обязательных требований - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY]: {
      title: 'Выявленные нарушения обязательных требований - Нарушенные обязательные требования',
      getScrollElementId: () => DECISION_VIOLATIONS,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ITEM]: {
      title: 'Выявленные нарушения обязательных требований - Содержание требования',
      getScrollElementId: () => DECISION_VIOLATIONS,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_REQUIREMENTS_MANDATORY_ITEM_CATEGORY]: {
      title: 'Выявленные нарушения обязательных требований - Значимость последствий нарушения',
      getScrollElementId: () => DECISION_VIOLATIONS,
    },

    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_KIND]: {
      title: 'Сведения о решении - Вид решения',
      getScrollElementId: () => DECISION_RESULT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_DOCUMENT]: {
      title: 'Сведения о решении - Документ решения',
      getScrollElementId: () => DECISION_RESULT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_DOCUMENT_ATTACHMENTS]: {
      title: 'Сведения о решении - Документ решения',
      getScrollElementId: () => DECISION_RESULT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_NOTES]: {
      title: 'Сведения о решении - Описание решения',
      getScrollElementId: () => DECISION_RESULT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_NOTE]: {
      title: 'Сведения о решении - Описание решения',
      getScrollElementId: () => DECISION_RESULT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION]: {
      title: 'Сведения о решении - Выявленные нарушения обязательных требований',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATIONS]: {
      title: 'Сведения о решении - Нарушения обязательных требований',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATIONS_MANDATORY]: {
      title: 'Сведения о решении - Устраняемые нарушения обязательных требований',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIXED_ON_PLACE]: {
      title: 'Сведения о решении - Нарушение устранено в ходе мероприятия',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIXED]: {
      title: 'Сведения о решении - Нарушение устранено',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_FIXES]: {
      title: 'Сведения о решении - Сведения о факте устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_PLAN_DATES]: {
      title: 'Сведения о решении - Плановая дата устранения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_PLAN_DATES_REQUIRED]: {
      title: 'Сведения о решении - Плановая дата устранения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_PLAN_DATE]: {
      title: 'Сведения о решении - Плановая дата устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_PLAN_METHODS]: {
      title: 'Сведения о решении - Планируемый способ устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIX_FACT_METHOD]: {
      title: 'Сведения о решении - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIX_FACT_METHOD_REQUIRED]: {
      title: 'Сведения о решении - Планируемый способ устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_PLAN_METHOD]: {
      title: 'Сведения о решении - Планируемый способ устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    // [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_PLAN_EXPLANATION]: {
    //   title: 'Сведения о решении - Пояснение инспектора к устранению',
    //   getScrollElementId: (id: string) => id,
    // },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_PLAN_EXPLANATION_REACT_QUILL_EDITOR]: {
      title: 'Сведения о решении - Пояснение инспектора к устранению',
      getScrollElementId: (id: string) => id,
    },

    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_PLAN_EXPLANATIONS]: {
      title: 'Сведения о решении - Пояснение инспектора к устранению',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_PLAN_EXPLANATIONS_REQUIRED]: {
      title: 'Сведения о решении - Пояснение инспектора к устранению',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPES]: {
      title: 'Сведения о решении - Тип материала',
      getScrollElementId: (id: string) => id,
    },
    // [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPE_EXPLANATION]: {
    //   title: 'Сведения о решении - Пояснение к материалу',
    //   getScrollElementId: (id: string) => id,
    // },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPE_EXPLANATION_REACT_QUILL_EDITOR]: {
      title: 'Сведения о решении - Пояснение к материалу',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPE]: {
      title: 'Сведения о решении - Тип материала',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIX_METHOD]: {
      title: 'Сведения о решении - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES]: {
      title: 'Сведения о решении - Файлы устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES_VIDEO_LINK]: {
      title: 'Сведения о решении - Ссылка на файл устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.VIOLATED_MANDATORY_ELIMINATION_VIOLATION_FIX_GRADE]: {
      title: 'Сведения о решении - Оценка исправления нарушения',
      getScrollElementId: (id: string) => id,
    },

    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION]: {
      title: 'Сведения о контролируемом лице',
      getScrollElementId: () => ORGANIZATION_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_IS_PRESENT_IN_IT_REGISTRY]: {
      title: 'Наличие в реестре аккредитованных IT-организаций',
      getScrollElementId: () => ORGANIZATION_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_INN]: {
      title: 'Идентификационный номер налогоплательщика (ИНН)',
      getScrollElementId: () => `organization.${INN_LABEL_BLOCK_ID}`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_OGRN]: {
      title: 'Основной государственный регистрационный номер (ОГРН)',
      getScrollElementId: () => `organization.${OGRN_LABEL_BLOCK_ID}`,
    },
    // [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_ORGANIZATION_NAME]: {
    //   title: 'Наименование проверяемого лица',
    //   getScrollElementId: () => `organization.${ORGANIZATION_NAME_BLOCK_ID}`,
    // },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_ORGANIZATION_NAME_REACT_QUILL_EDITOR]: {
      title: 'Наименование проверяемого лица',
      getScrollElementId: () => `organization.${ORGANIZATION_NAME_BLOCK_ID}`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_SNILS]: {
      title: 'Страховой номер индивидуального лицевого счета (СНИЛС)',
      getScrollElementId: () => `organization.${SNILS_BLOCK_ID}`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_DOCUMENT]: {
      title: 'Сведения о документе, удостоверяющем личность',
      getScrollElementId: () => `organization.${DOCUMENT_BLOCK_ID}`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_COUNTRY]: {
      title: 'Государство, в котором указанное лицо зарегистрировано',
      getScrollElementId: () => `organization.${COUNTRY_BLOCK_ID}`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_ORIGINAL_NAME]: {
      title: 'Наименование',
      getScrollElementId: () => `organization.${ORGANIZATION_NAME_BLOCK_ID}`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_RAFP_NZA]: {
      title: 'Номер записи об аккредитации в РАФП',
      getScrollElementId: () => `organization.${RAFP_NZA_BLOCK_ID}`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_KPP]: {
      title: 'Код причины постановки на учет (КПП)',
      getScrollElementId: () => `organization.${KPP_BLOCK_ID}`,
    },

    [DecisionFormFieldsNamesTemplatesEnum.PROSECUTOR_ORGANIZATION]: {
      title: 'Наименование прокуратуры',
      getScrollElementId: () => PROSECUTOR_ORGANIZATION_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.INSPECTORS]: {
      title: 'Сведения о должностных лицах, участвующих в КНМ, СР',
      getScrollElementId: () => INSPECTORS_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.INSPECTORS_FULLNAME]: {
      title: 'Сведения о должностных лицах, участвующих в КНМ, СР',
      getScrollElementId: () => INSPECTORS_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.INSPECTORS_POSITION]: {
      title: 'Сведения о должностных лицах, участвующих в КНМ, СР',
      getScrollElementId: () => INSPECTORS_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_DATE]: {
      title: 'Сведения о решении - Дата решения',
      getScrollElementId: () => DECISION_RESULT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_NUMBER]: {
      title: 'Сведения о решении - Номер решения',
      getScrollElementId: () => DECISION_RESULT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FIO_SIGNER]: {
      title: 'Сведения о решении - ФИО подписавшего решение',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_TITLE_SIGNER]: {
      title: 'Сведения о решении - Должность лица, подписавшего решение',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_ORGANIZATION_TYPE]: {
      title: 'Тип контролируемого лица',
      getScrollElementId: () => ORGANIZATION_BLOCK_ID,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATIONS_FIAS_REGION]: {
      title: 'Адрес места нахождения - Субъект РФ',
      getScrollElementId: () => ORGANIZATION_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_LOCATION_ADDRESS]: {
      title: 'Адрес места нахождения',
      getScrollElementId: () => `organization.${LOCATION_ADDRESS}`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.DOCUMENT_TYPE]: {
      title: 'Дополнительные документы, относящиеся к решению',
      getScrollElementId: () => KNM_DOCUMENTS,
    },
    [DecisionFormFieldsNamesTemplatesEnum.DOCUMENT_ATTACHMENTS]: {
      title: 'Дополнительные документы, относящиеся к решению',
      getScrollElementId: () => KNM_DOCUMENTS,
    },

    [DecisionFormFieldsNamesTemplatesEnum.OBJECTS]: {
      title: 'Сведения об объектах контроля',
      getScrollElementId: () => OBJECTS_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.OBJECT]: {
      title: 'Объект контроля',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_NAME]: {
      title: 'Наименование объекта контроля',
      getScrollElementId: (id: string) => getObjectNameBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.OBJECT_ADDRESS]: {
      title: 'Местонахождение объекта контроля',
      getScrollElementId: (id: string) => getObjectAddressBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_TYPE]: {
      title: 'Тип объекта контроля',
      getScrollElementId: (id: string) => getObjectTypeBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_KIND]: {
      title: 'Вид объекта контроля',
      getScrollElementId: (id: string) => getObjectKindBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_SUB_KIND]: {
      title: 'Подвид объекта контроля',
      getScrollElementId: (id: string) => getObjectSubKindBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.OBJECT_RISK_CATEGORY]: {
      title: 'Категория риска объекта контроля',
      getScrollElementId: (id: string) => getObjectRiskCategoryBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.OBJECT_DANGER_CLASS]: {
      title: 'Класс опасности объекта контроля',
      getScrollElementId: (id: string) => getObjectDangerClassBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.OBJECT_REGION]: {
      title: 'Регион местонахождения объекта контроля',
      getScrollElementId: (id: string) => getObjectRegionBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.OBJECT_MANUAL_ADDRESS]: {
      title: 'Адрес местонахождения объекта контроля',
      getScrollElementId: (id: string) => getObjectManualAddressBlockId(id),
    },

    [DecisionFormFieldsNamesTemplatesEnum.EVENTS]: {
      title: 'Перечень действий, осуществляемых в рамках КНМ, СР',
      getScrollElementId: () => EVENTS_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.EVENT]: {
      title: 'Действие, осуществляемое в рамках КНМ, СР',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.EVENT_TYPE]: {
      title: 'Тип действия, осуществляемого в рамках КНМ, СР',
      getScrollElementId: (id: string) => getEventTypeBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.EVENT_INTERACTION_CATEGORY]: {
      title: 'Категория взаимодействия осуществляемого действия',
      getScrollElementId: (id: string) => getEventInteractionCategoryBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.EVENT_START_DATE]: {
      title: 'Дата начала действия, осуществляемого в рамках КНМ, СР',
      getScrollElementId: (id: string) => getEventStartDateBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.EVENT_STOP_DATE]: {
      title: 'Дата окончания действия, осуществляемого в рамках КНМ',
      getScrollElementId: (id: string) => getEventStopDateBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS]: {
      title: 'Перечень действий - Представляемые документы',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_TITLE_ID]: {
      title: 'Перечень действий - Представляемые документы - Наименование',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_REQUEST_DATETIME_ID]: {
      title: 'Перечень действий - Представляемые документы - Дата и время запроса',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_DEADLINE_ID]: {
      title: 'Перечень действий - Представляемые документы - Срок представления',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_FILE_ID]: {
      title: 'Перечень действий - Представляемые документы - Файл',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_SUBMISSION_DATETIME_ID]: {
      title: 'Перечень действий - Представляемые документы - Дата и время получения документа',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },

    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_INJUNCTION_DATE_RESOLVED]: {
      title: 'Сведения о решении - Срок исполнения решения',
      getScrollElementId: () => DECISION_RESULT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_INJUNCTION_NOTE]: {
      title:
        'Сведения о решении - Информация о проведении мероприятий по предотвращению причинения вреда (ущерба) охраняемым законом ценностям',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_INJUNCTION_NOTE_REACT_QUILL_EDITOR]: {
      title:
        'Сведения о решении - Информация о проведении мероприятий по предотвращению причинения вреда (ущерба) охраняемым законом ценностям',
      getScrollElementId: (id: string) => id,
    },
    // JUDMENTS
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENTS]: {
      title: 'Сведения о судебных решениях',
      getScrollElementId: () => JUDGMENTS_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT]: {
      title: 'Сведения о судебном решении',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_DATE]: {
      title: 'Сведения о судебном решении - Дата судебного решения',
      getScrollElementId: (id: string) => getJudgmentDateBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_NUMBER]: {
      title: 'Сведения о судебном решении - Номер судебного решения',
      getScrollElementId: (id: string) => getJudgmentNumberBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_ATTACHMENT]: {
      title: 'Сведения о судебном решении - Файл решения',
      getScrollElementId: (id: string) => getJudgmentAttachmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_KIND]: {
      title: 'Сведения о судебном решении - Вид судебного решения',
      getScrollElementId: (id: string) => getJudgmentKindBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_REGION]: {
      title: 'Сведения о судебном решении - Субъект Российской Федерации',
      getScrollElementId: (id: string) => getJudgmentRfRegionBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_COURT]: {
      title: 'Сведения о судебном решении - Наименование суда',
      getScrollElementId: (id: string) => getJudgmentCourtBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_COURT_LEVEL]: {
      title: 'Сведения о судебном решении - Уровень суда',
      getScrollElementId: (id: string) => getJudgmentCourtLevelBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_ACTION]: {
      title: 'Сведения о судебном решении - Действие судебного решения',
      getScrollElementId: (id: string) => getJudgmentActionBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECTS_DATA]: {
      title: 'Сведения о судебном решении - Сведения о контролируемом лице',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA]: {
      title: 'Сведения о судебном решении - Сведения о контролируемом лице',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_GUID]: {
      title: 'Сведения о судебном решении - Сведения о контролируемом лице',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG]: {
      title: 'Сведения о судебном решении - Судебный акт принят в отношении контролируемого лица',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO]: {
      title: 'Сведения о судебном решении - Сведения о наказании контролируемого лица',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_PROSECUTION_TYPE]: {
      title: 'Сведения о судебном решении - Вид ответственности контролируемого лица',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_PUNISHMENT_TYPE]: {
      title: 'Сведения о судебном решении - Вид наказания контролируемого лица',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_AMOUNT_OF_PUNISHMENT]: {
      title: 'Сведения о судебном решении - Размер наказания контролируемого лица',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_PUNISHMENT_INDEX]: {
      title: 'Сведения о судебном решении - Показатель наказания контролируемого лица',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_ORG_INFO_NOTE_LAWSUITS]: {
      title: 'Сведения о судебном решении - Дополнительная информация о наказании контролируемого лица',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON]: {
      title: 'Сведения о судебном решении - Судебный акт принят в отношении должностного лица',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSONS]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_FIO]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - ФИО',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_JOB]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Должность',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_PROSECUTION_TYPE]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Вид ответственности',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_PUNISHMENT_TYPE]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Вид наказания',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_AMOUNT_OF_PUNISHMENT]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Размер наказания',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_PUNISHMENT_INDEX]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Показатель наказания',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_AGAINST_PERSON_INFO_NOTE_LAWSUITS]: {
      title: 'Сведения о судебном решении - Сведения о наказании должностного лица - Дополнительная информация',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_CANCELLATION_ACTS_AND_DECISIONS]: {
      title: 'Сведения о судебном решении - Сведения о решениях в рамках решения, которые отменены или изменены',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_CANCELLATION_ACT_OR_DECISION]: {
      title: 'Сведения о судебном решении - Сведения о решениях в рамках решения, которые отменены или изменены',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_CANCELLATION_ACT_OR_DECISION_CANCELLATION_INFO]: {
      title:
        'Сведения о судебном решении - Сведения о решениях в рамках решения, которые отменены или изменены - Отменено частично',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_SUBJECT_DATA_CANCELLATION_ACT_OR_DECISION_EXPLANATION]: {
      title:
        'Сведения о судебном решении - Сведения о решениях в рамках решения, которые отменены или изменены - Пояснение',
      getScrollElementId: (id: string) => getJudgmentSubjectDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENTS]: {
      title: 'Сведения о судебном решении - Сведения о судебных решениях в рамках решения, которые отменены',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT]: {
      title: 'Сведения о судебном решении - Сведения о судебном решении в рамках  решения, которое отменено',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_GUID]: {
      title: 'Сведения о судебном решении - Сведения о судебном решении в рамках решения, которое отменено',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ORG_CANCELLATION_INFO]: {
      title:
        'Сведения о судебном решении - Сведения о судебном решении в рамках решения, которое отменено - Отмена принятого решения',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ORG_EXPLANATION]: {
      title: 'Сведения о судебном решении - Сведения о судебном решении в рамках решения, которое отменено - Пояснение',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_PERSON_INFO_CANCELLATION_INFO]: {
      title:
        'Сведения о судебном решении - Сведения о судебном решении в рамках решения, которое отменено - Отмена принятого решения',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_PERSON_INFO_EXPLANATION]: {
      title: 'Сведения о судебном решении - Сведения о судебном решении в рамках решения, которое отменено - Пояснение',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ACT_OR_DECISION_CANCELLATION_INFO]: {
      title:
        'Сведения о судебном решении - Сведения о судебном решении в рамках решения, которое отменено - Отмена принятого решения',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.JUDGMENT_CANCELED_JUDGMENT_SUBJECT_DATA_ACT_OR_DECISION_EXPLANATION]: {
      title: 'Сведения о судебном решении - Сведения о судебном решении в рамках решения, которое отменено - Пояснение',
      getScrollElementId: (id: string) => getJudgmentBlockId(id),
    },

    [DecisionFormFieldsNamesTemplatesEnum.ACT]: {
      title: 'Сведения об акте',
      getScrollElementId: () => ACT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_NUMBER_ACT]: {
      title: 'Сведения об акте - Номер акта КНМ, СР',
      getScrollElementId: () => ACT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_CREATION_ACT_DATE_TIME]: {
      title: 'Сведения об акте - Дата и время составления акта КНМ, СР',
      getScrollElementId: () => ACT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_SIGN_ACT_DATE_TIME]: {
      title: 'Сведения об акте - Дата и время подписания акта КНМ, СР',
      getScrollElementId: () => ACT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_DOCUMENT]: {
      title: 'Сведения об акте - Файл акта',
      getScrollElementId: () => ACT_BLOCK_ID,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTORS]: {
      title: 'Сведения об акте - Должностные лица контрольного (надзорного) органа, участвовавшие в КНМ, СР',
      getScrollElementId: () => `${ACT_BLOCK_ID}.knoInspectors`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR]: {
      title: 'Сведения об акте - Должностное лицо контрольного (надзорного) органа, участвовавшие в КНМ, СР',
      getScrollElementId: () => `${ACT_BLOCK_ID}.knoInspectors`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_KNO_INSPECTOR]: {
      title: 'Сведения об акте - ФИО должностного лица контрольного (надзорного) органа, участвовавшие в КНМ, СР',
      getScrollElementId: () => `${ACT_BLOCK_ID}.knoInspectors`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_HOLDING_DATE_TIME]: {
      title: 'Сведения об акте - Дата и время начала проведения КНМ, СР',
      getScrollElementId: () => `${ACT_BLOCK_ID}.holdingDateTime`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_INVOLVED_WITNESSES_VALUE]: {
      title: 'Сведения об акте - Привлеченные к проверке свидетели',
      getScrollElementId: () => `${ACT_BLOCK_ID}.involvedWitnesses`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_DURATION_DAYS]: {
      title: 'Сведения об акте - Срок проведения (в днях)',
      getScrollElementId: () => `${ACT_BLOCK_ID}.durationDays`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_DURATION_HOURS]: {
      title: 'Сведения об акте - Срок проведения (в часах)',
      getScrollElementId: () => `${ACT_BLOCK_ID}.durationHours`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_EVENTS]: {
      title: 'Сведения об акте - Перечень осуществляемых действий',
      getScrollElementId: () => `${ACT_BLOCK_ID}.events`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_EVENT]: {
      title: 'Сведения об акте - Перечень осуществляемых действий',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_EVENT_TYPE]: {
      title: 'Сведения об акте - Тип действия, осуществляемого в рамках КНМ, СР',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_EVENT_INSPECTORS]: {
      title: 'Сведения об акте - Должностное лицо, осуществившее действие',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_EVENT_INSPECTOR_FULL_NAME]: {
      title: 'Сведения об акте - Должностное лицо, осуществившее действие',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_EVENT_START_DATE]: {
      title: 'Сведения об акте - Дата начала действия, осуществляемого в рамках КНМ, СР',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_EVENT_STOP_DATE]: {
      title: 'Сведения об акте - Дата окончания действия, осуществляемого в рамках КНМ, СР',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_EVENT_LINK_VKS]: {
      title: 'Сведения об акте - Ссылка на ВКС',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_EVENT_LINK_VIDEO]: {
      title: 'Сведения об акте - Ссылка на видеозапись',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_EVENT_PROTOCOL_FILE_ATTACHMENTS]: {
      title: 'Сведения об акте - Протокол проведенного действия',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_IS_VIOLATED_REQUIREMENTS_MANDATORY]: {
      title: 'Сведения об акте - Наличие обязательных требований',
      getScrollElementId: () => `act.isViolatedMandatoryRequirements`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS]: {
      title: 'Сведения об акте - Нарушенные обязательные требования',
      getScrollElementId: () => `act.isViolatedMandatoryRequirements`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE]: {
      title: 'Сведения об акте - Описание нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE_REACT_QUILL_EDITOR]: {
      title: 'Сведения об акте - Описание нарушения',
      // todo очень плохо, но пока незнаю как сделать лучше, компонента для нарушений используется в 3 местах
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED_ON_PLACE]: {
      title: 'Сведения об акте - Нарушение устранено в ходе мероприятия',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATIONS]: {
      title: 'Сведения об акте - Нарушения обязательных требований',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED]: {
      title: 'Сведения об акте - Нарушение устранено',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_REPEAT_CORRECTED]: {
      title: 'Сведения об акте - Нарушение устранено',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES_VIDEO_LINK]: {
      title: 'Сведения об акте - Ссылка на файл устранения нарушения',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES]: {
      title: 'Сведения об акте - Файлы устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION]: {
      title: 'Акт - Сведения о факте устранения нарушения',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPES]: {
      title: 'Сведения об акте - Тип материала',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPE]: {
      title: 'Сведения об акте - Тип материала',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_METHOD]: {
      title: 'Сведения об акте - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPE_EXPLANATION_REACT_QUILL_EDITOR]: {
      title: 'Сведения об акте - Пояснение',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },

    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY]: {
      title: 'Сведения об акте - Нарушенные обязательные требования',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM]: {
      title: 'Сведения об акте - Содержание требования',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_CATEGORY]: {
      title: 'Сведения об акте - Значимость последствий нарушения',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_FIO_AND_POSITION_SIGNER]: {
      title: 'Сведения об акте - ФИО подписавшего решение',
      getScrollElementId: () => `act.fioAndPositionSinger`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_TYPE]: {
      title: 'Акт - Способ уведомления',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTICE_DATE]: {
      title: 'Акт - Дата уведомления',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTE]: {
      title: 'Акт - Примечание',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_TYPE]: {
      title: 'Решение - Способ уведомления',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTICE_DATE]: {
      title: 'Решение - Дата уведомления',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTE]: {
      title: 'Решение - Примечание',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_SUBJECT_TYPE]: {
      title: 'Сведения о решении - Лицо, в отношении которого принято решение',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_INN]: {
      title: 'Сведения о решении - Идентификационный номер налогоплательщика (ИНН)',
      getScrollElementId: (id: string) => id.replace('inn', INN_LABEL_BLOCK_ID),
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_OGRN]: {
      title: 'Сведения о решении - Основной государственный регистрационный номер (ОГРН)',
      getScrollElementId: (id: string) => id.replace('ogrn', OGRN_LABEL_BLOCK_ID),
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_ORGANIZATION_TYPE]: {
      title: 'Сведения о решении - Тип учредителя',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_ORGANIZATION_NAME]: {
      title: 'Сведения о решении - Наименование учредителя',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_OKVEDS]: {
      title: 'Сведения о решении - Список ОКВЭД',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_OKVED]: {
      title: 'Сведения о решении - ОКВЭД',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_OKVED_OKVED]: {
      title: 'Сведения о решении - ОКВЭД',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_SNILS]: {
      title: 'Сведения о решении - Страховой номер индивидуального лицевого счета (СНИЛС)',
      getScrollElementId: (id: string) => id.replace('snils', SNILS_BLOCK_ID),
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_DOCUMENT]: {
      title: 'Сведения о решении - Сведения о документе, удостоверяющем личность',
      getScrollElementId: (id: string) => id.replace('document', DOCUMENT_BLOCK_ID),
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_COUNTRY]: {
      title: 'Сведения о решении - Государство, в котором указанное лицо зарегистрировано',
      getScrollElementId: (id: string) => id.replace('country', COUNTRY_BLOCK_ID),
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_ORIGINAL_NAME]: {
      title: 'Сведения о решении - Наименование',
      getScrollElementId: (id: string) => id.replace('originalName', ORGANIZATION_NAME_BLOCK_ID),
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_RAFP_NZA]: {
      title: 'Сведения о решении - Номер записи об аккредитации в РАФП',
      getScrollElementId: (id: string) => id.replace('rafpNza', RAFP_NZA_BLOCK_ID),
    },
    [DecisionFormFieldsNamesTemplatesEnum.RESULT_DECISION_FOUNDER_KPP]: {
      title: 'Сведения о решении - Код причины постановки на учет (КПП)',
      getScrollElementId: (id: string) => id.replace('kpp', KPP_BLOCK_ID),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_REMARKS_TEXT]: {
      title: 'Акт - Замечание - Текст замечания',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_REMARKS_TEXT_REACT_QUILL_EDITOR]: {
      title: 'Акт - Замечание - Текст замечания',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_REMARKS_SIGNER_FULLNAME]: {
      title: 'Акт - Замечание - ФИО лица, оставившего замечание',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_REMARKS_SIGNER_POSITION]: {
      title: 'Акт - Замечание - Должность лица, оставившего замечание',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_REMARKS_DATE]: {
      title: 'Акт - Замечание - Дата',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_VIOLATION_EVIDENCES_EXISTS]: {
      title: 'Фото (видео) фиксация потенциального нарушения ОТ',
      getScrollElementId: () => `${ACT_BLOCK_ID}.isViolationEvidenceExists`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_VIOLATION_EVIDENCES]: {
      title: 'Ссылка на видеозапись или фотоматериалы',
      getScrollElementId: () => `${ACT_BLOCK_ID}.violationEvidences`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_VIOLATION_EVIDENCES_DATE]: {
      title: 'Ссылка на видеозапись или фотоматериалы - Дата фиксации',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_VIOLATION_EVIDENCES_LINK]: {
      title: 'Ссылка на видеозапись или фотоматериалы - Ссылка',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_VIOLATION_EVIDENCES_DESCRIPTION]: {
      title: 'Ссылка на видеозапись или фотоматериалы - Фиксация потенциального нарушения',
      getScrollElementId: (id: string) => id?.replace('organization.', ''),
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASONS]: {
      title: 'Основание проведения мероприятий',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON]: {
      title: 'Основание проведения мероприятий',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_TYPE]: {
      title: 'Основания проведения мероприятий',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_TEXT]: {
      title: 'Дополнительно',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_DATE]: {
      title: 'Дата основания проведения мероприятий',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_DATE_REQUIREMENT]: {
      title: 'Дата требования проведения мероприятий',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_ASSIGNMENT_NUMBER]: {
      title: 'Номер поручения',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_ORDER]: {
      title: 'Номер поручения',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_ASSIGNMENT_DATE]: {
      title: 'Дата поручения',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_ASSIGNMENT_FULLNAME]: {
      title: 'ФИО лица, издавшего поручение',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_REQUIREMENT_DETAILS]: {
      title: 'Реквизиты требования',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATORS]: {
      title: 'Индикаторы риска',
      getScrollElementId: (id: string) => getDecisionRiskIndicatorsBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR]: {
      title: 'Индикатор риска',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATORS_AUTO]: {
      title: 'Индикатор риска - Индикатор срабатывает в автоматическом режиме',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATORS_FILE]: {
      title: 'Индикатор риска - Файл',
      getScrollElementId: (id: string) => id,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_LAST_CONDUCTED_KNM_DATE]: {
      title: 'Дата',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_PROGRAM_NUMBER]: {
      title: 'Номер программы проверок',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_PROGRAM_ATTACHMENT]: {
      title: 'Файл программы проверок',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_PROSECUTOR_ATTACHMENT]: {
      title: 'Файл, содержащий требование прокурора',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_PRESCRIPTION_DATE]: {
      title: 'Дата документа',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.REASON_PRESCRIPTION_NUMBER]: {
      title: 'Номер документа',
      getScrollElementId: () => DECISION_REASON,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_RESULT_PRESCRIPTION]: {
      title: 'Соглашение - Предписание',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.prescription`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS]: {
      title: 'Соглашение - Нарушения, включенные в соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.violations`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATIONS]: {
      title: 'Соглашение - Нарушения, включенные в соглашение - Нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIX_FACT_METHOD]: {
      title: 'Соглашение - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES]: {
      title: 'Соглашение - Сведения о факте устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPES]: {
      title: 'Соглашение - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE]: {
      title: 'Соглашение - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    // [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE_EXPLANATION]: {
    //   title: 'Соглашение - Пояснение к материалу',
    //   getScrollElementId: (id: string) => getComplexDataBlockId(id),
    // },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE_EXPLANATION_REACT_QUILL_EDITOR]: {
      title: 'Соглашение - Пояснение к материалу',
      getScrollElementId: (id: string) => {
        return getComplexDataBlockId(id);
      },
    },

    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_METHOD]: {
      title: 'Соглашение - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_FILES]: {
      title: 'Соглашение - Файлы устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_FILES_VIDEO_LINK]: {
      title: 'Соглашение - Ссылка на файл устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_GRADE]: {
      title: 'Соглашение - Оценка исправления нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_TYPE]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Лицо, с которым заключается соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganizationType`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ATTACHMENT]: {
      title: 'Соглашение - Файл ходатайства',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionAttachment`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_INN]: {
      title: 'Соглашение - Ходатайство контролируемого лица - ИНН',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.inn`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_OGRN]: {
      title: 'Соглашение - Ходатайство контролируемого лица - ОГРН',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.ogrn`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_SNILS]: {
      title: 'Соглашение - Ходатайство контролируемого лица - СНИЛС',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.snils`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_SUBJECT_TYPE]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Тип контролируемого лица',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.subjectType`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_ORGANIZATION_NAME]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Наименование проверяемого лица',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.organizationName`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_LOCATION_ADDRESS]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Адрес места нахождения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.organizationName`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVAL_OF_AGREEMENT]: {
      title: 'Соглашение - Решение об утверждении ходатайства',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approvalOfAgreement`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVAL_OF_AGREEMENT_ATTACHMENT]: {
      title: 'Соглашение - Файл решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approvalOfAgreementAttachment`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_ELIMINATE_VIOLATIONS_NUMBER]: {
      title: 'Соглашение - Соглашение об устранении нарушений',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.eliminateViolationsNumber`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_CONCLUSION_DATE]: {
      title: 'Соглашение - Дата заключения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.conclusionDate`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_COMPLETION_DATE]: {
      title: 'Соглашение - Срок исполнения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.termOfExecutionAgreement`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_ELIMINATE_VIOLATIONS_ATTACHMENT]: {
      title: 'Соглашение - Файл соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.eliminateViolationsAttachment`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_FIO_SIGNER]: {
      title: 'Соглашение - ФИО подписавшего соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.fioSigner`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_TITLE_SIGNER]: {
      title: 'Соглашение - Должность лица, подписавшего соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.titleSigner`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_APPLICATION_FOR_CONSIDERATION_ATTACHMENT]: {
      title: 'Соглашение - Заявление в органы прокуратуры о рассмотрении соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.applicationForConsiderationAttachment`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATION_CORRECTION_PROGRAM_ATTACHMENTS]: {
      title: 'Соглашение - Программа устранения нарушений',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.violationCorrectionProgramAttachments`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_PROSECUTOR_ORGANIZATION]: {
      title: 'Соглашение - Наименование прокуратуры',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.prosecutorOrganization`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_NOTE]: {
      title: 'Соглашение - Комментарий',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.note`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_APPROVED]: {
      title: 'Соглашение - Решение по заявлению',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.approved`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_NUMBER_DECISION]: {
      title: 'Соглашение - Номер решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.numberDecision`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_DATE_DECISION]: {
      title: 'Соглашение - Дата решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.dateDecision`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_WHO_MADE_DECISION]: {
      title: 'Соглашение - Кем принято решение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.whoMadeDecision`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_TITLE_SIGNER]: {
      title: 'Соглашение - Должность лица, подписавшего решение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.titleSigner`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_ATTACHMENT]: {
      title: 'Соглашение - Файл решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.attachment`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TERMINATION_REASONS]: {
      title: 'Соглашение - Основания для признания соглашения неисполненным и расторжения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.terminationReasons`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TERMINATION_REASONS_ITEM]: {
      title: 'Соглашение - Основания для признания соглашения неисполненным и расторжения соглашения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_DECISION_TERMINATION_ATTACHMENT]: {
      title: 'Соглашение - Решение о признании соглашения неисполненным и расторжении соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.decisionTerminationAttachment`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_FIO_SIGNER]: {
      title: 'Соглашение - ФИО принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.fioSigner`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TITLE_SIGNER]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.titleSigner`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TITLE_SIGNER_LABEL]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.titleSigner`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_DECISION]: {
      title: 'Соглашение - Решение об исполнении соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.decision`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_EXECUTION_DATE]: {
      title: 'Соглашение - Фактическая дата исполнения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.executionDate`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_TITLE_SIGNER]: {
      title: 'Соглашение - ФИО принявшего решение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.fioSigner`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_FIO_SIGNER]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.titleSigner`,
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TYPES]: {
      title: 'Соглашение - Вид изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TYPES_ITEM]: {
      title: 'Соглашение - Вид изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_REASON]: {
      title: 'Соглашение - Основание для изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_REASON_ITEM]: {
      title: 'Соглашение - Основание для изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_ATTACHMENTS]: {
      title: 'Соглашение - Решение об изменении',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TERM_OF_EXECUTION_AGREEMENT]: {
      title: 'Соглашение - Новый срок исполнения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_UPDATED_AGREEMENT_ATTACHMENTS]: {
      title: 'Соглашение - Обновленная версия соглашения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_PETITION_ATTACHMENTS]: {
      title: 'Соглашение - Ходатайство об изменении соглашения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_FIO_SIGNER]: {
      title: 'Соглашение - ФИО принявшего решение об изменении',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TITLE_SIGNER]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.UAV_TECHNOLOGIES]: {
      title: 'Сведения об использовании беспилотных технологий',
      getScrollElementId: () => UAV_TECHNOLOGIES,
    },
    [DecisionFormFieldsNamesTemplatesEnum.UAV_TECHNOLOGIES_TYPE]: {
      title: 'Вид беспилотника',
      getScrollElementId: (id: string) => getUavTechnologiesTypeBlockId(id),
    },
    [DecisionFormFieldsNamesTemplatesEnum.UAV_TECHNOLOGIES_NAME]: {
      title: 'Название беспилотника',
      getScrollElementId: (id: string) => getUavTechnologiesNameBlockId(id),
    },
  };
};
